module.exports = __webpack_public_path__ + "static/media/4.b87ef518.png";